import React, { createContext, useState, useContext, useCallback } from 'react';

const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);

const Modal = ({ modalContent, hideModal }) => {
    if (!modalContent) return null;

    const { title, message, type } = modalContent;
    const bgColor = type === 'error' ? 'bg-red-100 border-red-500' : type === 'success' ? 'bg-green-100 border-green-500' : 'bg-blue-100 border-blue-500';
    const textColor = type === 'error' ? 'text-red-700' : type === 'success' ? 'text-green-700' : 'text-blue-700';

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
            <div className={`bg-white p-6 rounded-lg shadow-xl w-full max-w-md border-l-4 ${bgColor}`}>
                <h3 className={`text-xl font-bold mb-4 ${textColor}`}>{title}</h3>
                <p className="text-gray-800">{message}</p>
                <div className="mt-6 text-right">
                    <button
                        onClick={hideModal}
                        className="bg-gray-600 hover:bg-gray-700 text-white font-semibold py-2 px-6 rounded-md"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};


export const ModalProvider = ({ children }) => {
    const [modalContent, setModalContent] = useState(null);

    const showModal = useCallback((content) => {
        setModalContent(content);
    }, []);

    const hideModal = useCallback(() => {
        setModalContent(null);
    }, []);

    return (
        <ModalContext.Provider value={{ showModal, hideModal }}>
            {children}
            <Modal modalContent={modalContent} hideModal={hideModal} />
        </ModalContext.Provider>
    );
};
